






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class DiameterTable extends Vue {
  @Prop({ default: false }) readonly!: boolean
  @Prop({ required: true }) vehicleTypes!: string[]
  @Prop({ default: '' }) suffix!: string
  @Prop({ default: () => [] }) rules!: Array<(v: any) => boolean | string>
  @Prop({ required: true }) getValue!: (vehicleType: string, diameter: number) => number

  private diameterList = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 22.5, 23]

  private getValueFromParent(vehicleType: string, diameter: number): number {
    return this.getValue(vehicleType, diameter)
  }

  private updateValue(vehicleType: string, diameter: number, value: string | number): void {
    this.$emit('update-value', vehicleType, diameter, value)
  }

  private getVehicleTypeLabel(vehicleType: string): string {
    const labels: { [key: string]: string } = {
      diameters: 'Standard',
      standard: 'Standard',
      suv: 'SUV',
      van: 'VAN',
    }
    return labels[vehicleType] || vehicleType.toUpperCase()
  }
}
